import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from '../finance/shared';

const AgeCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [birthDate, setBirthDate] = useState('2000-01-01');
  const [targetDate, setTargetDate] = useState(new Date().toISOString().split('T')[0]);
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    if (!birthDate || !targetDate) return;
    const birth = new Date(birthDate);
    const target = new Date(targetDate);
    if (birth > target) return;

    let years = target.getFullYear() - birth.getFullYear();
    let months = target.getMonth() - birth.getMonth();
    let days = target.getDate() - birth.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(target.getFullYear(), target.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    const totalDays = Math.floor((target.getTime() - birth.getTime()) / (1000 * 60 * 60 * 24));
    const zodiacSign = ((d: Date) => {
      const m = d.getMonth() + 1, dy = d.getDate();
      if ((m === 3 && dy >= 21) || (m === 4 && dy <= 19)) return 'Áries';
      if ((m === 4 && dy >= 20) || (m === 5 && dy <= 20)) return 'Touro';
      if ((m === 5 && dy >= 21) || (m === 6 && dy <= 20)) return 'Gêmeos';
      if ((m === 6 && dy >= 21) || (m === 7 && dy <= 22)) return 'Câncer';
      if ((m === 7 && dy >= 23) || (m === 8 && dy <= 22)) return 'Leão';
      if ((m === 8 && dy >= 23) || (m === 9 && dy <= 22)) return 'Virgem';
      if ((m === 9 && dy >= 23) || (m === 10 && dy <= 22)) return 'Libra';
      if ((m === 10 && dy >= 23) || (m === 11 && dy <= 21)) return 'Escorpião';
      if ((m === 11 && dy >= 22) || (m === 12 && dy <= 21)) return 'Sagitário';
      if ((m === 12 && dy >= 22) || (m === 1 && dy <= 19)) return 'Capricórnio';
      if ((m === 1 && dy >= 20) || (m === 2 && dy <= 18)) return 'Aquário';
      return 'Peixes';
    })(birth);

    const res = { years, months, days, totalDays, zodiacSign };
    setResult(res);
    onResultChange([
      { label: 'Idade', value: `${years} anos, ${months} meses e ${days} dias` },
      { label: 'Total de Dias', value: totalDays.toLocaleString('pt-BR') },
      { label: 'Signo', value: zodiacSign }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="Data de Nascimento" value={birthDate} onChange={setBirthDate} type="date" required />
          <FormField label="Data de Referência" value={targetDate} onChange={setTargetDate} type="date" required />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover transition-all flex items-center gap-2">
            <Icon name="play" className="w-5 h-5" /> Calcular Idade
          </button>
        </div>
        {result && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <ResultCard title="Idade" value={`${result.years} anos`} description={`${result.months} meses e ${result.days} dias`} color="indigo" />
            <ResultCard title="Total de Dias" value={result.totalDays.toLocaleString('pt-BR')} color="emerald" />
            <ResultCard title="Signo" value={result.zodiacSign} color="purple" />
          </div>
        )}
      </div>
    </div>
  );
};

export default AgeCalculator;
